import { useCheckFlag } from '@speeki/feature-flags';
import { StorageManager } from '@speeki/storage-manager';

import { UserBasicDocument } from '@graphql/generated/graphql';

import { useQuery, useReactiveVar } from '@apollo/client';
import { authVar } from '@boot/reactiveVariables';

export const useUserBasic = () => {
    const mfaMetadata = StorageManager.getValue('metadata');
    const isLoggedIn = useReactiveVar(authVar).isLoggedIn;

    const isEngagementFeatureEnabled = useCheckFlag(
        'client_admin-stakeholder_engagement-20250312',
    );

    return useQuery(UserBasicDocument, {
        context: {
            logoutOnError: true,
        },
        fetchPolicy: 'cache-and-network',
        skip: !isLoggedIn || !!mfaMetadata,
        variables: {
            isEngagementFeatureEnabled,
        },
    });
};
